<template>
  <FormCard class="impersonate-pm" v-loading="loading">
    <ElForm>
      <ElFormItem>
        <span slot="label"> Accounts </span>
        <p class="w-full m-0 p-0">Select the account for impersonate.</p>
        <el-select v-model="accountSelected" filterable class="w-full" placeholder="Select">
          <el-option v-for="item in accounts" :key="item.agency_brand_id" :label="item.name" :value="item.agency_brand_id"> </el-option>
        </el-select>
      </ElFormItem>
      <el-button type="primary" :disabled="!accountSelected" @click="impersonate" icon="el-icon-connection">Impersonate</el-button>
    </ElForm>
  </FormCard>
</template>
<script>
import FormCard from '@/components/social-products/social-boost/parts/FormCard.vue'

export default {
  components: {
    FormCard,
  },
  data() {
    return {
      accounts: [],
      loading: false,
      accountSelected: '',
    }
  },
  created() {
    this.init()
  },
  computed: {
    redirect() {
      return this.$route.path
    },
  },
  methods: {
    async init() {
      this.loading = true
      try {
        const { data } = await this.axios.get('/api/social-products/social-boost/accounts/impersonate')
        this.accounts = data || []
      } catch (err) {
      } finally {
        this.loading = false
      }
    },
    impersonate() {
      window.location.href = `/impersonate/${this.accountSelected}?redirect=${this.redirect}`
    },
  },
}
</script>
<style lang="scss">
.impersonate-pm {
  .el-form-item__label {
    display: block;
    width: 100%;
    text-align: left;
    line-height: 0px;
  }
}
</style>
